export const MerchantSelectionStyles = {
  loadingContainer: 'flex flex-col justify-center my-6',
  iconContainer: 'items-center grid mr-auto ml-8',
  backIcon: 'cursor-pointer h-4 sm:h-8',
}
